import { useContext } from "react";
import { Text } from "../../components/text/text";
import { LocaleContext } from "../../contexts/locale/locale";
import { Page } from "../page/page";

export const Privacy = () => {
	const { texts } = useContext(LocaleContext);

	return (
		<Page title={texts.privacy.hero.title} image="/images/home.jpg">
			<Text
				title={texts.privacy.hero.title}
				paragraphs={texts.privacy.paragraphs}
			/>
		</Page>
	);
};
